import { render, staticRenderFns } from "./student-location-modal.vue?vue&type=template&id=09f633e2&scoped=true"
import script from "./student-location-modal.vue?vue&type=script&lang=js"
export * from "./student-location-modal.vue?vue&type=script&lang=js"
import style0 from "./student-location-modal.vue?vue&type=style&index=0&id=09f633e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f633e2",
  null
  
)

export default component.exports